module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    staticClass: "prod-body"
  }, [_c('div', {
    staticClass: "prod-head",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1000"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "prod-intro"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.beads_title'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prod-intro-text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('message.beads_intro'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "prod-accordions-wrap"
  }, _vm._l((_vm.$t('message.beads_main_accordions')), function(accordions, index) {
    return _c('AccordionMain', {
      key: index,
      attrs: {
        "content": _vm.$t('message.beads_main_accordions')[index],
        "data-aos": "fade-up",
        "data-aos-duration": "1000"
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prod-img"
  }, [_c('div', {
    staticClass: "prod-opacity"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f14b33de","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Beads.vue
// module id = 369
// module chunks = 0